var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNmRateCardNumber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 170.1 170.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .dummy-widget-rate-card-nm-cls-1 {\n        fill: #1e1e1e;\n      }\n\n      .dummy-widget-rate-card-nm-cls-1, .dummy-widget-rate-card-nm-cls-2, .dummy-widget-rate-card-nm-cls-3, .dummy-widget-rate-card-nm-cls-4, .dummy-widget-rate-card-nm-cls-5, .dummy-widget-rate-card-nm-cls-6, .dummy-widget-rate-card-nm-cls-7, .dummy-widget-rate-card-nm-cls-8, .dummy-widget-rate-card-nm-cls-9 {\n        stroke-width: 0px;\n      }\n\n      .dummy-widget-rate-card-nm-cls-10 {\n        clip-path: url(#dummy-widget-rate-card-nm-clippath);\n      }\n\n      .dummy-widget-rate-card-nm-cls-2 {\n        fill: none;\n      }\n\n      .dummy-widget-rate-card-nm-cls-3 {\n        fill: #4a494a;\n      }\n\n      .dummy-widget-rate-card-nm-cls-4 {\n        fill: #7c7c7c;\n      }\n\n      .dummy-widget-rate-card-nm-cls-5 {\n        fill: #393a3a;\n      }\n\n      .dummy-widget-rate-card-nm-cls-11 {\n        opacity: .7;\n      }\n\n      .dummy-widget-rate-card-nm-cls-6 {\n        fill: #86c0ea;\n      }\n\n      .dummy-widget-rate-card-nm-cls-7 {\n        fill: #2b2b2b;\n      }\n\n      .dummy-widget-rate-card-nm-cls-8 {\n        fill: #202020;\n      }\n\n      .dummy-widget-rate-card-nm-cls-9 {\n        fill: #223a80;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "dummy-widget-rate-card-nm-clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-rate-card-nm-cls-2",
    x: 7.5,
    y: 7.8,
    width: 155.1,
    height: 155.1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-rate-card-nm-cls-5",
    y: 0.3,
    width: 170.1,
    height: 170.1,
    rx: 7.6,
    ry: 7.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-rate-card-nm-cls-10"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-rate-card-nm-cls-1",
    d: "M14.4,45.3h141.7c3.4,0,6.1,2.7,6.1,6.1v67.7c0,3.4-2.7,6.1-6.1,6.1H14.2c-3.4,0-6.1-2.7-6.1-6.1V51.5c0-3.4,2.8-6.2,6.2-6.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-rate-card-nm-cls-7",
    d: "M156,125.4H14.2c-3.5,0-6.3-2.8-6.3-6.3V51.5c0-3.5,2.8-6.4,6.4-6.4h141.8c3.5,0,6.3,2.8,6.3,6.3v67.7c0,3.5-2.7,6.3-6.3,6.3ZM14.3,45.5c-3.3,0-6,2.7-6,6v67.6c0,3.3,2.6,5.9,5.9,5.9h141.9c3.3,0,5.9-2.6,5.9-5.9V51.4c0-3.3-2.6-5.9-5.9-5.9H14.3Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-rate-card-nm-cls-3",
    x: 17.6,
    y: 103.2,
    width: 42.1,
    height: 5.5,
    rx: 2.2,
    ry: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-rate-card-nm-cls-3",
    d: "M67.9,103.2h37.8c1.2,0,2.2,1,2.2,2.2v1.1c0,1.2-1,2.2-2.2,2.2h-37.8c-1.2,0-2.2-1-2.2-2.2v-1.1c0-1.2,1-2.2,2.2-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-rate-card-nm-cls-3",
    d: "M115.9,103.2h37.8c1.2,0,2.2,1,2.2,2.2v1.1c0,1.2-1,2.2-2.2,2.2h-37.8c-1.2,0-2.2-1-2.2-2.2v-1.1c0-1.2,1-2.2,2.2-2.2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-rate-card-nm-cls-9",
    d: "M66.4,65.6h24.4c4.4,0,8,3.6,8,8v1.8c0,4.4-3.6,8-8,8h-24.4c-4.4,0-8-3.6-8-8v-1.8c0-4.4,3.6-8,8-8Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-rate-card-nm-cls-4",
    d: "M34.5,76c0,2.6-.5,4.6-1.6,6-1.1,1.4-2.7,2.1-4.8,2.1s-3.6-.7-4.7-2c-1.1-1.4-1.6-3.3-1.7-5.8v-3.5c0-2.6.5-4.6,1.6-6s2.7-2.1,4.7-2.1,3.6.7,4.7,2c1.1,1.3,1.6,3.3,1.7,5.8v3.5h0ZM30.7,72.2c0-1.6-.2-2.7-.6-3.4s-1.1-1.1-2-1.1-1.5.3-2,1-.6,1.7-.7,3.2v4.6c0,1.5.2,2.7.6,3.4.4.7,1.1,1.1,2,1.1s1.6-.4,2-1.1.6-1.8.6-3.3v-4.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-rate-card-nm-cls-4",
    d: "M45.8,76.3c-1,1-2.1,1.4-3.4,1.4s-3-.6-4-1.7-1.5-2.7-1.5-4.6.3-2.4.8-3.4,1.3-1.8,2.3-2.4,2.1-.9,3.3-.9,2.4.3,3.3.9,1.7,1.5,2.3,2.7c.5,1.2.8,2.5.8,4v1.4c0,3.1-.8,5.6-2.3,7.4-1.6,1.8-3.8,2.8-6.7,2.9h-.9v-3.1h.8c3.3-.2,5-1.7,5.3-4.6h0ZM43.3,74.8c.6,0,1.1-.2,1.6-.5.4-.3.8-.7,1-1.1v-1.5c0-1.3-.2-2.3-.7-3s-1.1-1.1-1.9-1.1-1.4.3-1.9,1-.7,1.6-.7,2.6.2,1.9.7,2.5,1.1,1,2,1h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-rate-card-nm-cls-6",
    d: "M77.4,73.2l1-1.7h1.7l-1.6,2.8,1.7,3h-1.7l-1-1.8-1,1.8h-1.7l1.7-3-1.6-2.8h1.7l1,1.7h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-rate-card-nm-cls-6",
    d: "M82.9,73.2l1-1.7h1.7l-1.6,2.8,1.7,3h-1.7l-1-1.8-1,1.8h-1.7l1.7-3-1.6-2.8h1.7l1,1.7h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-rate-card-nm-cls-6",
    d: "M86.2,71.6c0-.4,0-.8.4-1,.3-.3.6-.4,1.1-.4s.8,0,1.1.4c.3.3.4.6.4,1.1v.3c0,.4,0,.8-.4,1-.3.3-.6.4-1.1.4s-.8,0-1.1-.4c-.3-.3-.4-.6-.4-1.1v-.3ZM87.1,72c0,.2,0,.3.2.5s.3.2.4.2.3,0,.4-.2c0,0,.2-.3.2-.5v-.4c0-.2,0-.3-.2-.5s-.3-.2-.4-.2-.3,0-.4.2-.2.3-.2.5v.4ZM88,76.8l-.7-.4,3.4-5.5.7.4-3.4,5.5ZM89.5,75.6c0-.4,0-.8.4-1,.3-.3.6-.4,1.1-.4s.8,0,1.1.4c.3.3.4.6.4,1.1v.3c0,.4,0,.8-.4,1s-.6.4-1.1.4-.8,0-1.1-.4c-.3-.3-.4-.6-.4-1.1v-.4h0ZM90.5,75.9c0,.2,0,.3.2.5s.3.2.4.2c.4,0,.6-.2.6-.7v-.4c0-.2,0-.3-.2-.5s-.3-.2-.4-.2-.3,0-.4.2-.2.3-.2.5v.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "dummy-widget-rate-card-nm-cls-6",
    points: "70.4 74.1 68 71.4 65.5 74.1 65.3 73.9 68 71.1 70.6 73.9 70.4 74.1"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-rate-card-nm-cls-6",
    x: 67.9,
    y: 71.3,
    width: 0.2,
    height: 6.4
  })))), /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-rate-card-nm-cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-rate-card-nm-cls-8",
    d: "M13.6-40.9h142.3c3.4,0,6.1,2.7,6.1,6.1V25.9c0,3.4-2.7,6.1-6.1,6.1H13.6c-3.4,0-6.1-2.7-6.1-6.1v-60.7c0-3.4,2.7-6.1,6.1-6.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-rate-card-nm-cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-rate-card-nm-cls-8",
    d: "M13.6,138.6h142.3c3.4,0,6.1,2.7,6.1,6.1v61c0,3.4-2.7,6.1-6.1,6.1H13.6c-3.4,0-6.1-2.7-6.1-6.1v-61c0-3.4,2.7-6.1,6.1-6.1Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNmRateCardNumber);
export default __webpack_public_path__ + "static/media/nm_rate_card_number.744ee420.svg";
export { ForwardRef as ReactComponent };